"use client";

import { ArrowDown } from "lucide-react";

/** CTA + Teilen-Buttons im Artikel-Hero. */
export default function HeroActions() {
  function scrollToContent() {
    document.getElementById("artikel-start")?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div className="flex flex-col sm:flex-row items-center gap-4">
      <button
        onClick={scrollToContent}
        className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-paper text-ink text-sm font-bold min-h-[48px] shadow-lg shadow-ink/20 hover:bg-paper-deep transition-colors duration-200 cursor-pointer"
      >
        Jetzt lesen
        <ArrowDown size={15} aria-hidden="true" />
      </button>
    </div>
  );
}
